import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { NavMenu } from '@uhg-abyss/web/ui/NavMenu';
import { Text } from '@uhg-abyss/web/ui/Text';
import { Header as AbyssHeader } from '@uhg-abyss/web/ui/Header';
import { Layout } from '@uhg-abyss/web/ui/Layout';
import { Brandmark } from '@uhg-abyss/web/ui/Brandmark';
import { IconSymbol } from '@uhg-abyss/web/ui/IconSymbol';
import { SelectInput } from '@uhg-abyss/web/ui/SelectInput';
import { useRouter } from '@uhg-abyss/web/hooks/useRouter';
import { useMediaQuery } from '@uhg-abyss/web/hooks/useMediaQuery';
import { UserObj, useAuth } from '@src/Providers/AuthProvider';
import { DateTime } from 'luxon';
import { getEEMSURL, getEnvironment } from '@src/env.config';
import { Alert } from '@uhg-abyss/web/ui/Alert';
import type { RootState } from '../../store/AppStore';
import { useLazyGetAnnouncementQuery } from '@src/store/services/LoginServices';

export const Header = ({ isHome }) => {
  const router = useRouter();
  const { service } = router.getRouteParams();
  const [_, setIsOpen] = useState(false);
  const [isInternal, setIsInternal] = useState(false);
  const [reportType, setReportType] = useState('');
  const [cstTime, setCstTime] = useState(
    DateTime.now().setZone('America/Chicago')
  );
  const [announceMessage, setAnnounceMessage] = useState('');
  const matches = useMediaQuery('(min-width: 500px)');
  const reportTypeValCurrent = useSelector((state: RootState) => {
    return state.reportTypeVal.value;
  });
  const { isAuth, user, userMap, userAccessCall, logout } = useAuth();
  const [getAnnoucement] = useLazyGetAnnouncementQuery();
  // const dispatch = useDispatch();
  const isToggled = useSelector((state) => state?.listOfValues?.isToggled);

  useEffect(() => {
    setIsInternal(user?.userType === 'I');
    const currentURI = window.location.href;
    const uriParts = currentURI.split('/');

    if (uriParts[6] != undefined) setReportType(uriParts[6]);
    else setReportType('Welcome');
  }, []);

  useEffect(() => {
    if (reportTypeValCurrent) {
      setReportType(reportTypeValCurrent);
    }
  }, [reportTypeValCurrent]);

  const handleLogout = () => {
    logout();
  };

  const handleHomeClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (isHome) window.location.reload();
    localStorage.removeItem('globalFilter');
    router.navigate(service || '/');
  };
  useEffect(() => {
    if (!isAuth) return;
    const fetchAnnouncement = async () => {
      const response = await getAnnoucement();
      if (response?.isSuccess) {
        setAnnounceMessage(response?.data);
      }
    };
    fetchAnnouncement();
  }, [isToggled, isAuth]);

  useEffect(() => {
    const interval = setInterval(() => {
      setCstTime(DateTime.now().setZone('America/Chicago'));
    }, 1000); // update every second

    return () => clearInterval(interval);
  }, []);

  return (
    <>
      <AbyssHeader.Container
        css={{
          'abyss-header-root': {
            backgroundColor:
              'var(--abyss-colors-web-semantic-color-surface-container-secondary)',
            boxShadow: 'rgba(0, 0, 0, 0.1) 0px 1px 2px 0px',
            width: '100%',
            position: 'sticky',
            top: '0px',
            zIndex: 3000,
            justifyContent: 'space-between',
            padding: '8px 16px',
          },
          'abyss-header-container': {
            maxWidth: 'none',
          },
        }}
      >
        <Layout.Group>
          <AbyssHeader.HamburgerMenu
            onClick={() => {
              setIsOpen(true);
            }}
            type="button"
            aria-label="Menu"
            aria-haspopup="dialog"
            css={{ display: 'flex' }}
          >
            <IconSymbol
              icon="menu"
              color="$web.semantic.color.icon.interactive.rest.primary"
            />{' '}
          </AbyssHeader.HamburgerMenu>
          <AbyssHeader.Brandmark
            logo={
              <Brandmark
                size="20px"
                affiliate="uhc"
                variant="u_mark"
                color="blue"
                brand="uhc"
              />
            }
          />
          <Text
            css={{
              display: 'flex',
              alignItems: 'center',

              margin: '8px 16px',
              paddingLeft: '12px',
              borderLeft: '2px solid #E5E5E6',
              color: '#7D7F81',
              fontSize: '18px',
              fontWeight: 600,
              height: '60px',
            }}
          >
            EEMS
          </Text>
        </Layout.Group>

        <Layout.Group space={20}>
          {announceMessage?.anncStsCd === 'AC' && (
            <Alert
              status="info"
              isVisible
              onClose={() => setAnnounceMessage('')}
            >
              {announceMessage?.anncTxt}
            </Alert>
          )}
        </Layout.Group>

        {matches && isAuth && (
          <Layout.Group space={20}>
            {/* White background for this nav menu only (the shared
                nav-menu.color.surface.container.header token keeps the bottom
                bar blue). Override its CSS variable here so it scopes locally. */}
            <div
              style={
                {
                  '--abyss-colors-navMenu-color-surface-container-header':
                    '#ffffff',
                  '--abyss-colors-navMenu-color-surface-interactive-header-hover-default':
                    '#FBF9F4',
                } as React.CSSProperties
              }
            >
              <NavMenu.Root zIndex={20} hasOverlay>
                <NavMenu.List>
                  <NavMenu.Item>
                    <Layout.Stack>
                      <NavMenu.Link href="#">
                        <Layout.Group
                          space={0}
                          alignLayout="right"
                          style={{ marginLeft: '200px' }}
                        >
                          <Text
                            css={{
                              color: '$web.semantic.color.text.content.primary',
                            }}
                          >
                            User
                          </Text>
                          <div
                            style={{
                              display: 'flex',
                              justifyContent: 'center',
                              alignItems: 'center',
                              height: '14px',
                              width: '14px',
                              marginLeft: '4px',
                              fontSize: '10px',
                              fontWeight: 700,
                            }}
                          >
                            <IconSymbol
                              icon="person"
                              size="14px"
                              color="$web.semantic.color.icon.interactive.rest.primary"
                            />
                          </div>
                        </Layout.Group>
                      </NavMenu.Link>
                      <Layout.Group>
                        <Text
                          css={{
                            fontWeight: 'light',
                            textTransform: 'capitalize',
                            color: '$web.semantic.color.text.content.primary',
                          }}
                        >
                          <strong>Time: </strong>
                          {cstTime.toFormat('MM/dd/yyyy HH:mm')} CST
                        </Text>

                        <Text
                          css={{
                            fontWeight: 'light',
                            textTransform: 'capitalize',
                            color: '$web.semantic.color.text.content.primary',
                          }}
                        >
                          <strong>Env:{getEnvironment()}</strong>
                        </Text>
                      </Layout.Group>
                    </Layout.Stack>
                  </NavMenu.Item>
                </NavMenu.List>
              </NavMenu.Root>
            </div>
          </Layout.Group>
        )}
      </AbyssHeader.Container>
      {/* Nav bar brand colors (blue bar, white links) are driven by the
          component-token overrides in theme/brandOverrides.ts, so no CSS-variable
          hacks are needed here. */}
      <div style={{ padding: 0, margin: 0 }}>
        <NavMenu.Root
          hasOverlay
          css={{
            'abyss-nav-menu-root': {
              justifyContent: 'space-between',
            },
            'abyss-nav-menu-container': {
              maxWidth: 'none',
            },
          }}
        >
          <Layout.Group
            css={{ justifyContent: 'space-between', width: '100%' }}
          >
            <NavMenu.List>
              <NavMenu.Item>
                <NavMenu.Link href="#">
                  <span onClick={handleHomeClick}>Home</span>
                </NavMenu.Link>
              </NavMenu.Item>
              {isAuth ? (
                <>
                  {user?.viewProfile ? (
                    <NavMenu.Item>
                      <NavMenu.Link href="/profile/search">
                        View Profile
                      </NavMenu.Link>
                    </NavMenu.Item>
                  ) : null}
                  {user?.addProfile ? (
                    <NavMenu.Item>
                      <NavMenu.Link href="/profile/add">
                        Add Profile
                      </NavMenu.Link>
                    </NavMenu.Item>
                  ) : null}
                  {user?.editRolePage ? (
                    <NavMenu.Item>
                      <NavMenu.Link href="/home/roleAdmin">
                        Role Admin
                      </NavMenu.Link>
                    </NavMenu.Item>
                  ) : null}
                  {user?.editAnnouncePage ? (
                    <NavMenu.Item>
                      <NavMenu.Link href="/home/announce">
                        Announcement
                      </NavMenu.Link>
                    </NavMenu.Item>
                  ) : null}
                </>
              ) : null}

              {/* {isAuth ? (
                <>
                  {user?.viewProfile && getEnvironment() !== 'prod' ? (
                    <NavMenu.Item>
                      <NavMenu.Link
                        href={`${getEEMSURL()}profile.do`}
                      >
                        OLD-View Profile
                      </NavMenu.Link>
                    </NavMenu.Item>
                  ) : null}
                  {user?.addProfile ? (
                    <NavMenu.Item>
                      <NavMenu.Link
                        href={`${getEEMSURL()}emptyProfile.do`}
                      >
                        OLD-Add Profile
                      </NavMenu.Link>
                    </NavMenu.Item>
                  ) : null}
                </>
              ) : null} */}
            </NavMenu.List>
            {isHome ? (
              <NavMenu.List>
                {userMap && userMap?.length ? (
                  <NavMenu.Item>
                    <SelectInput
                      label=""
                      placeholder="User"
                      value={user?.userId}
                      width={'160px'}
                      onChange={(value) => {
                        const uObj: UserObj | undefined = userMap?.find((x) => {
                          return x.userId === value;
                        });
                        userAccessCall(uObj);
                      }}
                      options={
                        userMap?.map(({ userId, userType }) => {
                          return {
                            label: `${userId} (${userType})`,
                            value: userId,
                          };
                        }) || []
                      }
                      customRender={(option) => (
                        <span style={{ fontSize: '14px' }}>{option.label}</span>
                      )}
                      css={{
                        'abyss-select-input-container': {
                          fontSize: '14px !important',
                        },
                      }}
                    />
                  </NavMenu.Item>
                ) : null}
              </NavMenu.List>
            ) : null}
            {isAuth ? (
              <NavMenu.List>
                <NavMenu.Item>
                  <NavMenu.Link href={`/home/help/${reportType}`}>
                    Help
                  </NavMenu.Link>
                </NavMenu.Item>
                <NavMenu.Item>
                  <NavMenu.Link onClick={handleLogout}>Logout</NavMenu.Link>
                </NavMenu.Item>
              </NavMenu.List>
            ) : null}
          </Layout.Group>
        </NavMenu.Root>
      </div>
    </>
  );
};
